import { render, staticRenderFns } from "./ProductCartBar.vue?vue&type=template&id=2ca71ace&scoped=true&"
import script from "./ProductCartBar.vue?vue&type=script&lang=js&"
export * from "./ProductCartBar.vue?vue&type=script&lang=js&"
import style0 from "./ProductCartBar.vue?vue&type=style&index=0&id=2ca71ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca71ace",
  null
  
)

export default component.exports